import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '../../ui/dialog';
import { CreateOrderQuoteForm } from './CreateOrderQuoteForm';

/* ════════════════════════ MODAL ════════════════════════ */

export function CreateOrderQuoteModal({
	open,
	onOpenChange,
	onSuccess,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onSuccess?: () => void;
}) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-lg">
				<DialogHeader>
					<DialogTitle>New quote</DialogTitle>
					<DialogDescription>
						Create a new quote for a client organization.
					</DialogDescription>
				</DialogHeader>

				<CreateOrderQuoteForm
					open={open}
					onCancel={() => onOpenChange(false)}
					onCreated={() => {
						onOpenChange(false);
						onSuccess?.();
					}}
				/>
			</DialogContent>
		</Dialog>
	);
}
